/* projects/common-module/src/lib/app-components/app-version/app-version.component.scss */
/*# sourceMappingURL=app-version.component.css.map */
